import React, {Component} from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import {LOGO, LOGO_INTERNAL} from '~/constants/ResponsiveImageConstants';
import {
  SHOPPING_CART_CONFIRM,
  SHOPPING_CART_CONFIRM_DIRTY
} from '~/constants/NotificationConstants';
import {isEditDesignInCartMode} from '~/utils/url';

// components
import CartOverlay from '~/components/CartOverlay';
import Menu from '~/shared/components/Menu';
import MainMenuButton from '~/components/MainMenuButton';
import Ttarp from '~/components/Ttarp';
import ShoppingCartIconWrapper from '~/components/ShoppingCartIconWrapper';
import {getCheckoutSummaryLink} from '../../constants/CheckoutLink';

import './index.scss';

const propTypes = {
  cartItemCount: PropTypes.number,
  currentProduct: PropTypes.object,
  designDirty: PropTypes.bool,
  internal: PropTypes.bool,
  isDesignBlank: PropTypes.bool,
  isDesignDirty: PropTypes.bool,
  isFullScreen: PropTypes.bool,
  isFundraisingMode: PropTypes.bool,
  menuActive: PropTypes.bool,
  prompt: PropTypes.func,
  welcome: PropTypes.bool,
  onChatClick: PropTypes.func,
  onLogoClick: PropTypes.func,
  onMainMenuClick: PropTypes.func
};

/** @extends {Component<PropTypes.InferProps<typeof propTypes>>} */
class InkyHeader_Lg extends Component {
  static displayName = 'InkyHeader_Lg';
  static propTypes = propTypes;

  static defaultProps = {
    isDesignBlank: false,
    isDesignDirty: false,
    isFullScreen: false,
    cartItemCount: 0
  };

  constructor(props) {
    super(props);

    this.headerCart = React.createRef();
    this.handleClickOutsideOverlay = this.handleClickOutsideOverlay.bind(this);
    this.state = {
      showCartOverlay: false
    };
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutsideOverlay);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutsideOverlay);
  }

  handleClickOutsideOverlay(e) {
    if (!this.headerCart.current.contains(e.target)) {
      this.setState({showCartOverlay: false});
    }
  }

  collectNodeHeight = node => {
    if (node) {
      this._height = node.clientHeight;
    } else {
      this._height = 0;
    }
  };

  logoImage() {
    return this.props.internal ? LOGO_INTERNAL : LOGO;
  }

  toggleCartOverlay = () => {
    if (this.state.showCartOverlay) {
      this.setState({showCartOverlay: false});
    } else {
      this.setState({showCartOverlay: true});
    }
  };

  openCartOverlay = () => {
    clearTimeout(this.closeTimeout);
    this.setState({showCartOverlay: true});
  };

  closeCartOverlay = () => {
    this.closeTimeout = setTimeout(
      () => this.setState({showCartOverlay: false}),
      400
    );
  };

  navigateToCheckout = () => {
    if (this.props.designDirty) {
      const key = isEditDesignInCartMode()
        ? SHOPPING_CART_CONFIRM
        : SHOPPING_CART_CONFIRM_DIRTY;
      this.props.prompt({key});
    } else {
      window.location.href = getCheckoutSummaryLink();
    }
  };

  renderCartOverlay() {
    return (
      <div
        className="ndx-CartOverlay"
        onMouseEnter={this.openCartOverlay}
        onMouseLeave={this.closeCartOverlay}>
        <CartOverlay />
      </div>
    );
  }

  render() {
    const {
      cartItemCount,
      isFundraisingMode,
      menuActive,
      onChatClick,
      onLogoClick,
      onMainMenuClick,
      welcome,
      isFullScreen
    } = this.props;

    const headerClasses = cl('ndx-InkyHeader_Lg', {
      'ndx-InkyHeader_Lg--welcome': welcome
    });
    const logoImage = this.logoImage();

    return (
      <div ref={this.collectNodeHeight} className="ndx-InkyHeader_Lg-wrapper">
        <Menu className={headerClasses}>
          {!isFullScreen && (
            <MainMenuButton isOpen={menuActive} onClick={onMainMenuClick} />
          )}
          <div
            className={
              isFullScreen
                ? 'ndx-InkyHeader_Lg-fullScreen'
                : 'ndx-InkyHeader_Lg-main'
            }>
            <img
              alt="customink logo Inky"
              className={`ndx-Logo${this.props.internal ? '-internal' : ''}`}
              src={logoImage}
              onClick={onLogoClick}
            />
          </div>
          <div ref={this.headerCart}>
            <div className="ndx-InkyHeader_Lg-options">
              <Ttarp
                cartItemCount={cartItemCount}
                isFundraisingMode={isFundraisingMode}
                onChatClick={onChatClick}
              />

              <ShoppingCartIconWrapper
                onCartHoverIn={this.openCartOverlay}
                onCartHoverOut={this.closeCartOverlay}
                onCartClick={this.navigateToCheckout}
              />
            </div>
            {this.state.showCartOverlay ? this.renderCartOverlay() : ''}
          </div>
        </Menu>
      </div>
    );
  }
}

export default InkyHeader_Lg;
